import { createApp } from "vue";

import SignInForm from "~/components/SignInForm.vue";

const el = document.getElementById("sign-in-form");
if (el) {
  createApp(SignInForm, {
    csrfParam: el.dataset.csrfParam,
    csrfToken: el.dataset.csrfToken,
    formAction: el.dataset.formAction
  }).mount(el);
}
